module.exports = __webpack_public_path__ + "static/media/logo-blue.5ff4d2b5.svg";